export default "__VITE_ASSET__6257a82e__"